import { defineComponent, ref, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, Fragment, renderList, createVNode, unref, toDisplayString } from 'vue';
import { useKeenSlider as z } from './basler-components.es361.js';
import _sfc_main$1 from './basler-components.es220.js';
/* empty css                        */

const _hoisted_1 = ["id"];
const _hoisted_2 = ["data-idx", "data-current"];
const _hoisted_3 = {
  key: 0,
  class: "card-carousel-section__dots"
};
const _hoisted_4 = ["aria-current", "onClick"];
const _hoisted_5 = { class: "card-carousel-section__dot-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CardCarouselSection",
  props: {
    id: {},
    colorMode: { default: "light" },
    items: {},
    negativeTop: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const current = ref(0);
    const [container, slider] = z({
      loop: true,
      selector: ".card-carousel-section__slide",
      initial: current.value,
      slideChanged: (slider2) => {
        current.value = slider2.track.details.rel;
      },
      slides: {
        perView: 1,
        spacing: 6
      },
      breakpoints: {
        "(min-width: 768px)": {
          slides: {
            origin: "center",
            perView: "auto",
            spacing: 38
          }
        }
      }
    });
    const isBehindActive = (idx) => {
      return idx === current.value + 1 || idx === 0 && current.value === props.items.length - 1;
    };
    const onClick = (event, idx) => {
      const isNotActive = idx !== current.value;
      if (isNotActive && slider.value) {
        event.preventDefault();
        if (isBehindActive(idx)) {
          slider.value.next();
        } else {
          slider.value.prev();
        }
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: _ctx.id,
        class: normalizeClass([
          "card-carousel-section",
          `card-carousel-section--color-${_ctx.colorMode}`,
          { "card-carousel-section--negative-top": _ctx.negativeTop },
          { "theme-light": _ctx.colorMode === "light" || _ctx.colorMode === "white" },
          { "theme-dark": _ctx.colorMode === "dark" || _ctx.colorMode === "black" }
        ])
      }, [
        createElementVNode("ul", {
          ref_key: "container",
          ref: container,
          class: "card-carousel-section__stage"
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (item, idx) => {
            return openBlock(), createElementBlock("li", {
              key: item.content.headline,
              class: normalizeClass([
                "card-carousel-section__slide",
                { "is-active": idx === current.value },
                { "is-inactive": idx !== current.value },
                {
                  "is-behind-active": isBehindActive(idx)
                }
              ]),
              "data-idx": idx,
              "data-current": current.value
            }, [
              createVNode(_sfc_main$1, {
                link: item.content.link,
                header: item.content.header,
                badge: item.content.badge,
                headline: item.content.headline,
                content: item.content.content,
                "header-gutter": false,
                date: item.content.date,
                "link-icon-position": "title",
                onClick: ($event) => onClick($event, idx)
              }, null, 8, ["link", "header", "badge", "headline", "content", "date", "onClick"])
            ], 10, _hoisted_2);
          }), 128))
        ], 512),
        props.items && unref(slider) ? (openBlock(), createElementBlock("ul", _hoisted_3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (item, idx) => {
            return openBlock(), createElementBlock("li", {
              key: item.title
            }, [
              createElementVNode("button", {
                class: "card-carousel-section__dot",
                "aria-current": idx === current.value ? true : void 0,
                onClick: ($event) => unref(slider)?.moveToIdx(idx)
              }, [
                createElementVNode("span", _hoisted_5, toDisplayString(item.title), 1)
              ], 8, _hoisted_4)
            ]);
          }), 128))
        ])) : createCommentVNode("", true)
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
